module.exports = __webpack_public_path__ + "img/trees-badge.5c984f1d.png";